import PresetCard from "@components/presetCard";
import { SanityCardWidget } from "@sourceful/shared-types";
import ProductCard from "@components/productCard";
import React from "react";
import { PRODUCT_CARD_WIDTH } from "@components/productCard/genericProductCard";
import GenericCard from "@components/genericCard/GenericCard";
import ResponsiveCarousel from "./ResponsiveCarousel";

const GRID_GAP = 30;

interface CardRowProps {
  hasGridGap: boolean;
  widgets: SanityCardWidget[];
  constrainContent: boolean;
}

const CardRow = ({ widgets, hasGridGap: gridGap, constrainContent }: CardRowProps) => {
  const Widgets = widgets.map(widget => {
    switch (widget._type) {
      case "productCardInstance":
        return (
          <ProductCard
            key={widget.productCard._id}
            card={widget}
            className="carousel-card product-card" // classnames specific to use in ResponsiveCarousel for spacing
          />
        );
      case "presetCardInstance":
        return (
          <PresetCard
            key={widget.presetCard._id}
            card={widget}
            className="carousel-card product-card" // classnames specific to use in ResponsiveCarousel for spacing
          />
        );
      case "genericCardInstance":
        return (
          <GenericCard key={widget._key} card={widget} className="carousel-card generic-card" />
        );
      default:
        return null;
    }
  });

  return (
    <ResponsiveCarousel
      gridGap={gridGap ? GRID_GAP : 0}
      numItems={widgets.length}
      itemWidth={PRODUCT_CARD_WIDTH}
      constrainContent={constrainContent}
    >
      {Widgets}
    </ResponsiveCarousel>
  );
};

export default CardRow;
